module.exports = __webpack_public_path__ + "static/media/home.8266c031.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshot/home.jpg
// module id = 58
// module chunks = 0